import loginReducer from './loginReducer';
import messageReducer from './message';
import productsReducer from './products';
import selectedProductReducer from './selectedProduct';
import graphFieldsReducer from './graphFieldsReducer';
import graphReducer from './graphReducer';
import {combineReducers} from 'redux';

const allReducers = combineReducers({  //top level obj returned, when you look at obj returned in console...
    currentLogin: loginReducer, 
    message : messageReducer,
    allProducts: productsReducer,
    selectedProduct: selectedProductReducer,
    graphFields: graphFieldsReducer,
    graph: graphReducer
});

export default allReducers;
